import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CSVFileService } from 'src/app/services/csvFile.service';
declare let $: any;

@Component({
  selector: 'app-load-csv-files',
  templateUrl: './load-csv-files.component.html',
  styleUrls: ['./load-csv-files.component.scss']
})
export class LoadCsvFilesComponent {
  files = [
    {
      id: 1,
      name: 'Cajas',
      endPoint: 'api/erp/bank/cash/csv',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/bank/plantilla_cajas.csv',
      fileName: 'plantilla_cajas.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 2,
      name: 'Cuentas Bancarias',
      endPoint: 'api/erp/bank/account/csv',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/bank/plantilla_bancos.csv',
      fileName: 'plantilla_bancos.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 3,
      name: 'Clientes',
      endPoint: 'api/erp/inventory/csv/upload/clients',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/inventory/plantilla_clientes.csv',
      fileName: 'plantilla_clientes.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 4,
      name: 'Proveedores',
      endPoint: 'api/erp/inventory/csv/upload/providers',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/inventory/plantilla_proveedores.csv',
      fileName: 'plantilla_proveedores.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 5,
      name: 'Bodegas',
      endPoint: 'api/erp/inventory/csv/upload/warehouses',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/inventory/plantilla_bodegas.csv',
      fileName: 'plantilla_bodegas.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 6,
      name: 'Existencia',
      endPoint: 'api/erp/inventory/csv/upload/existence',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/inventory/plantilla_existencia.csv',
      fileName: 'plantilla_existencia.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 7,
      name: 'Productos',
      endPoint: 'api/erp/inventory/csv/upload/products',
      //templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/inventory/plantilla_productos.csv',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/inventory/plantilla_productos.xlsx',
      // fileName: 'plantilla_productos.csv',
      fileNane: 'plantilla_productos.xlsx',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 8,
      name: 'Anticipos Entrantes',
      endPoint: 'api/erp/bank/advances/in/csv',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/bank/plantilla_anticipos.csv',
      fileName: 'plantilla_anticipos.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 9,
      name: 'Anticipos Salientes',
      endPoint: 'api/erp/bank/advances/out/csv',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/bank/plantilla_anticipos.csv',
      fileName: 'plantilla_anticipos.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
    {
      id: 10,
      name: 'Propiedad Planta y equipo',
      endPoint: 'api/erp/propertyEquipment/register/items/csv',
      templateUrl: 'https://inin-templates.s3-us-west-2.amazonaws.com/inERP/ppye/template_ppe.csv',
      templateUrl2: 'https://inin-templates.s3-us-west-2.amazonaws.com/Plantilla-PPE.pdf',
      fileName: 'plantilla_propiedad_planta_equipo.csv',
      fileName2: 'manual_propiedad_planta_equipo.pdf',
      show2nd: true,
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },{
      id: 11,
      name: 'Productos Favoritos',
      endPoint: 'api/erp/inventory/csv/upload/products-favorite',
      templateUrl: 'https://s3-us-west-2.amazonaws.com/inin-templates/inERP/inventory/plantilla_existencia.csv',
      fileName: 'plantilla_existencia.csv',
      uploadFile: null,
      button: new ButtonLoading("btn-success", false, "Cargar Archivo", 'fa-upload')
    },
  ];
  errors: any[] =  null;

  constructor(
    private csvService: CSVFileService,
    private toastService: ToastrService
  ) {

  }

  onFileChange(event: Event, file): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files?.length) {
      file.uploadFile = inputElement.files[0];
    }
  }

  selectFile(index) {
    $('#file' + index).click();
  }

  upload(file) {
    if (file.button.loading) {
      return;
    }
    file.button.loading = true;
    this.csvService.uploadFile(file).subscribe({
      next: (response: ResponseObject) => {
        file.button.loading = false;
        file.uploadFile = null;
        if (!response.data.ok) {
          this.errors = response.data.errors;
        } else {
          this.toastService.success(response.data.message);
        }
      }, error: (response) => {
        file.button.loading = false;
        this.toastService.error("Error al cargar el archivo");
      }
    })
  }
}
